function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
}
let timeinterval = "";

//   const deadline = new Date(Date.parse(new Date()) + 15 * 24 * 60 * 60 * 1000);
//   initializeClock("clockdiv", deadline);
function initializeClock(id, endtime) {
  // debugger;
  // const clock = document.getElementById(id);
  // const daysSpan = clock.querySelector(".days");
  // const hoursSpan = clock.querySelector(".hours");
  // const minutesSpan = clock.querySelector(".minutes");
  // const secondsSpan = clock.querySelector(".seconds");

  function updateClock() {
    // console.log("hi");
    const t = getTimeRemaining(endtime);

    // console.log(t.seconds);

    // document.querySelector("header").innerText = t.seconds;

    document.getElementById(id).querySelector(".days").innerHTML = toPersianNum(
      t.days
    );
    document.getElementById(id).querySelector(".hours").innerHTML = (
      "۰" + toPersianNum(t.hours)
    ).slice(-2);
    document.getElementById(id).querySelector(".minutes").innerHTML = (
      "۰" + toPersianNum(t.minutes)
    ).slice(-2);
    document.getElementById(id).querySelector(".seconds").innerHTML = (
      "۰" + toPersianNum(t.seconds)
    ).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  timeinterval = setInterval(updateClock, 1000);
}
function toPersianNum(num, dontTrim) {
  // alert("hi");
  // alert("hj");
  var i = 0,
    dontTrim = dontTrim || false,
    num = dontTrim ? num.toString() : num.toString().trim(),
    len = num.length,
    res = "",
    pos,
    persianNumbers =
      typeof persianNumber == "undefined"
        ? ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"]
        : persianNumbers;

  for (; i < len; i++)
    if ((pos = persianNumbers[num.charAt(i)])) res += pos;
    else res += num.charAt(i);

  return res;
}
function toSeperatedNum(num) {
  // alert("hi");
  const arr = num.toString().split("");
  const counter = 3;
  // console.log(arr);
  const newArr = arr.map((item, i) => {
    const x = (num.length - i) % counter;
    // console.log(x);

    if (x == 1) {
      // alert("hi");
      return `${item},`;
    } else return item;
    // const
  });

  return newArr.join("").replace(/.$/, "");
  // e.target.value = input.substring(0, input.length - 1);
}
function toPureNum(num) {
  const arr = num.toString().split("");
  return num.replace(/,/g, "");
}
function toEnglishNum(string) {
  return string
    .replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
}
// function startTimer(duration, display) {
//   var timer = duration,
//     minutes,
//     seconds;
//   // console.log("timer", timer);
//   timerT = setInterval(function () {
//     minutes = parseInt(timer / 60, 10);
//     seconds = parseInt(timer % 60, 10);

//     minutes = minutes < 10 ? "0" + minutes : minutes;
//     seconds = seconds < 10 ? "0" + seconds : seconds;

//     display.textContent = toPersianNum(minutes) + ":" + toPersianNum(seconds);

//     if (--timer < 0) {
//       timer = duration;
//     }
//     if (timer == 0) {
//       clearInterval(timerT);
//       callUserBtn.classList.remove("hide");
//       timerDisp.innerText = "00:00";
//     }
//   }, 1000);
// }
const selectEndInput = (el) => {
  console.log(el.target.selectionStart, "start");
  console.log(el.target.end, "end");
  if (el.target.selectionStart == 0)
    el.target.selectionStart = el.target.selectionEnd = el.target.value.length;
};
const inputToPersian = (e) => {
  let input = e.target.value;

  e.target.value = toPersianNum(input, true);
  // const last = input.split("").pop();
  // // console.log("last", last);
  // if (last >= "0" && last <= "9") {
  //   e.target.value = input.substring(0, input.length - 1);
  //   // console.log(toString(e.target.value));
  //   e.target.value += toPersianNum(last);
  // }
};
function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}
const inputToSeperated = (e) => {
  let input = e.target.value;
  const newInput = input.replace(/,/g, "");
  // alert("bye");
  // console.log("hi", input);
  const chars = input.split("");
  // console.log("last", last);
  if (chars.length > 3) e.target.value = toSeperatedNum(newInput);
};

function cleanObj(obj) {
  for (var propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === ""
    ) {
      // console.log("deleted");
      delete obj[propName];
    }
  }
  return obj;
}

let Selected_car_index = 0;

var is_cartype_selected = false;

//

const shownText = (text) => {
  if (text == null) return "نامشخص";

  if (text.length < 20) return text;

  const length = text.length;

  const shownLength = Math.floor((length * 75) / 100);

  const restText = text.substring(shownLength, length);
  const n = restText.indexOf("،");

  const shownText = text.substring(0, shownLength + n);

  return `${shownText}...`;
};

//

export { toPersianNum, toSeperatedNum, shownText, toEnglishNum };
